<div class="db-ecommerce-setup-done db-platform-account-upgraded" [ngClass]="{'for-mobile': forMobileEdit}">
  <div *ngIf="!forMobileEdit">
    <img class="mb10" src="assets/images/icons/account_upgraded_stars.svg" alt="stars"/>
    <div class="header-content sub-header">
      <span [innerHTML]="'text_successfullyUpgradedDemo' | dbText : {subscription: subscription?.plan?.title}"></span>
    </div>
    <div class="header-content header" [style.line-height]="campaignInfo && !isMobile ? '48px' : '32px'">
      @if (campaignInfo) {
        <span>{{!!campaignInfo ? (campaignInfo?.couponDays == 30 ? '1 month' : campaignInfo?.couponDays + ' days') : '7 days'}} free
         <ng-container *ngIf="!!campaignInfo?.couponPercent">
            &<br/> <span class="discount-text" *ngIf="!!campaignInfo?.couponPercent">{{campaignInfo?.couponPercent}}% off</span>
         </ng-container></span>
      }@else {
        <span [innerHTML]="'text_successfullyUpgradedDemoHeader' | dbText"></span>
      }
    </div>
    <div class="header-content desc">
      <span [innerHTML]="(isEcommerce ? 'text_successfullyUpgradedDemoDescSuccess' : 'text_successfullyUpgradedDemoDescSuccessBasic') | dbText"></span></div>
    <ul class="db-demo-success__points">
      <li *ngFor="let point of isEcommerce ? points['ecommerce'] : points['basic']">
        <img class="db-checkmark" src="assets/images/icons/checkmark-new.svg" alt="checkmark"/>
        <span [innerHTML]="point"></span>
      </li>
    </ul>
  </div>

  @if (isMobile) {
    <div class="magic-link-container">
      <p class="magic-link-heading">
        @if (forMobileEdit) {
          To edit your site, visit {{ companyName }}<br/> on your desktop.
        } @else {
          To edit your site, visit {{ companyName }} on your desktop.
        }
      </p>
    </div>
  } @else {
    <div class="db-platform-account-upgraded__buttons-wrap text-center mt30">
      <a class="ds-btn-black ds-btn-max rectangle"   target="_blank"
         rel="noopener noreferrer" [href]="wpAdminUrl"   (click)="proceed(); onEditCLick.emit()">
        <span>Edit Your Website</span></a>
    </div>
  }

</div>
